/**
 * 2022-01-14
 * 带图片切换标签页组件：SwitchTabWithImage
 */
import Image from '@/components/UI/Image';
import { VideoModule } from '@/componentsH5/ProductComponents';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect, useRef, useState } from 'react';
import TextModule from '../TextModule';
import css from './index.module.scss';
const defaultStyle = {
    position: 'top',
    backColor: '#fff',
    height: 'auto',
    cardText: false,
    videoLoop: false,
};

const defaultData = [
    {
        tab: 'EV station charging',
        subTab: 'DELTA Pro is compatible ',
        key: 'k1',
        videoUrl: '"/video/aboutus.mp4"',
        imgUrl: '/img/drone-air.jpg',
        textTitle: 'Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'Solar charging',
        subTab: 'DELTA Pro is compatible ',
        key: 'k2',
        videoUrl: '"/video/aboutus.mp4"',
        imgUrl: '/img/house_big.jpg',
        textTitle: '2) Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'wind turbine',
        subTab: 'DELTA Pro is compatible ',
        key: 'k3',
        videoUrl: '"/video/aboutus.mp4"',
        imgUrl: '/img/drone-air.jpg',
        textTitle: '3) Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
    {
        tab: 'wall charge',
        subTab: 'DELTA Pro is compatible ',
        key: 'k4',
        videoUrl: '"/video/aboutus.mp4"',
        imgUrl: '/img/house_big.jpg',
        textTitle: '4) Power pretty much anything ',
        textDesc:
            'DELTA Pro is compatible with 90% of portable solar panels. And with a 1600W input, you can charge up in as fast as 2.8 hours. Integrate DELTA Pro with your home using the Smart Home Panel and use your rooftop panels to charge up too¹. ',
        textSupliment: '¹While the grid is on-line, supports panels up to 150V, 3000W, requires use of a dedicated accessory (sold separately). ',
        showVideo: false,
    },
];

const textTitleDefaultStyle = {
    textAlign: 'center',
    fontSize: '.24rem',
    lineHeight: '.34rem',
    color: '#03060b',
    fontFamily: 'var(--font-family-Bold)',
    padding: 0,
};
const textDescDefaultStyle = {
    textAlign: 'center',
    fontSize: '.14rem',
    lineHeight: '.22rem',
    color: 'rgb(119,119,119)',
    fontFamily: 'var(--font-family-Medium)',
    margin: '.08rem 0 0 0',
    padding: 0,
};
const textSuplimentDefaultStyle = {
    textAlign: 'center',
    fontSize: '.12rem',
    lineHeight: '.16rem',
    color: 'rgb(145,145,145)',
    fontFamily: 'var(--font-family-Regular)',
    margin: '.16rem 0 0 0',
    padding: 0,
};

/**
 *
 * @param cssStyle{
 *   position: 图片/视频位置 string,  // top(default), bottom, left, right
 *   backColor: 背景色 string,
 *   height: 高度 string,
 * }
 *
 * @param data[
 * {
 * tab： tab文本,
 * subTab: tab副文本,
 * key：key值,
 * videoUrl: 视频地址,
 * imgUrl：图片地址,
 * textTitle: 主标题文本,
 * textDesc: 说明文字文本,
 * textSupliment：补充文字文本,
 * showVideo：是否显示视频(视频和图片只展示一种)
 * }
 * ]
 */

export default function SwitchTabModule({ cssStyle, data = defaultData }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    if (!styles.imgHeight) {
        styles.imgHeight = '3rem';
    }
    const { position, backColor, height, wordSpacing, letterSpacing, videoLoop } = styles;
    const [activeKey, setActiveKey] = useState(0);
    const [item, setItem] = useState(data[0]);
    const { useLang } = useGlobal();
    const { t } = useLang('product');
    const { EFPic } = createEFPic(styles?.webpUrl);
    const tabsWrapper = useRef(null);

    const changeTab = (key: any) => {
        setItem(data.filter((list: any, k: number) => k === key)[0]);
        setActiveKey(key);
    };

    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (tabsWrapper.current) {
            (tabsWrapper.current as unknown as HTMLUListElement).style.left = `${
                window.innerWidth - (tabsWrapper.current as unknown as HTMLUListElement).offsetWidth
            }px`;
        }
    }, [tabsWrapper]);

    return (
        <div
            className={`${css.switchTabWithImage} switchTabWithImage font-family-semibold`}
            style={{
                background: backColor,
                height: height,
                wordSpacing: wordSpacing,
                letterSpacing: letterSpacing,
            }}
        >
            {/* 1. 顶部视频/图片 position: top */}
            {position === 'top' && (
                <div className="wrapper wrapperTop">
                    {item.showVideo ? (
                        <div className="videoBox">
                            <VideoModule
                                config={{
                                    height: '3rem',
                                    src: item.videoUrl,
                                    autoPlay: true,
                                    hideControl: true,
                                    muted: true,
                                    loop: videoLoop,
                                }}
                            />
                        </div>
                    ) : (
                        <div className="imgBox signFullImgsBox" style={{ height: styles.imgHeight }}>
                            {Array.isArray(item.imgUrl) ? (
                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                            ) : (
                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                            )}
                        </div>
                    )}
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'} style={{ marginTop: '0.3rem' }}>
                        <div className="tabBox">
                            <ul
                                className="tabsWrapper"
                                ref={tabsWrapper}
                                onTouchStart={touchStart}
                                onTouchMove={touchMove}
                                style={{
                                    display: styles.cardText ? 'contents' : 'block',
                                }}
                            >
                                {data.map((list: any, k: number) => (
                                    <li
                                        className={`tab font-family-semibold ${activeKey === k ? 'activeTab' : ''} ${
                                            backColor === '#fff' ? 'whiteTab' : 'blackTab'
                                        }`}
                                        key={k}
                                        onClick={() => activeKey !== k && changeTab(k)}
                                    >
                                        {list.tab}
                                    </li>
                                ))}
                                <p className="line" style={{ opacity: backColor === '#fff' ? '1' : '0.2' }}></p>
                            </ul>
                        </div>
                        {!styles.cardText && (
                            <div className="textContainer">
                                <TextModule
                                    data={{ text: item.textTitle }}
                                    cssStyle={{
                                        ...textTitleDefaultStyle,
                                        ...{
                                            backColor: backColor,
                                            color: backColor === '#fff' ? '#03060b' : '#fff',
                                        },
                                    }}
                                />
                                <TextModule
                                    data={{ text: item.textDesc }}
                                    cssStyle={{
                                        ...textDescDefaultStyle,
                                        ...{
                                            backColor: backColor,
                                            color: backColor === '#fff' ? '#222' : 'rgb(145,145,145)',
                                        },
                                    }}
                                />
                                <TextModule
                                    data={{ text: item.textSupliment }}
                                    cssStyle={{
                                        ...textSuplimentDefaultStyle,
                                        ...{
                                            backColor: backColor,
                                            color: backColor === '#fff' ? 'rgb(145,145,145)' : 'rgb(105,105,105)',
                                        },
                                    }}
                                />
                            </div>
                        )}
                        {styles.cardText && (
                            <div className="card-text-container">
                                {item.textArr.map((text: any, i: any) => (
                                    <div className="card-text-content" key={i}>
                                        <div className="content-left">
                                            <div className="title">{text.title}</div>
                                            <div className="desc">{text.desc}</div>
                                            <div className="phrase">{text.phrase}</div>
                                        </div>
                                        <div className="content-right">
                                            <div className="count">
                                                {text.count}
                                                <span className="unit">{text.unit}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {/* 2. 底部视频/图片 position: bottom */}
            {position === 'bottom' && (
                <div className="wrapper wrapperBottom">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'}>
                        <div className="tabBox">
                            <ul className="tabsWrapper" onTouchStart={touchStart} onTouchMove={touchMove}>
                                {data.map((list: any, k: number) => (
                                    <li
                                        className={`tab font-family-semibold ${activeKey === k ? 'activeTab' : ''} ${
                                            backColor === '#fff' ? 'whiteTab' : 'blackTab'
                                        }`}
                                        key={k}
                                        onClick={() => activeKey !== k && changeTab(k)}
                                    >
                                        {list.tab}
                                    </li>
                                ))}
                                <p className="line" style={{ opacity: backColor === '#fff' ? '1' : '0.2' }}></p>
                            </ul>
                        </div>
                        <div className="textContainer">
                            <TextModule
                                data={{ text: item.textTitle }}
                                cssStyle={{
                                    ...textTitleDefaultStyle,
                                    ...{
                                        backColor: backColor,
                                        color: backColor === '#fff' ? '#03060b' : '#fff',
                                    },
                                }}
                            />
                            <TextModule
                                data={{ text: item.textDesc }}
                                cssStyle={{
                                    ...textDescDefaultStyle,
                                    ...{
                                        backColor: backColor,
                                        color: backColor === '#fff' ? '#03060b' : 'rgb(145,145,145)',
                                    },
                                }}
                            />
                            <TextModule
                                data={{ text: item.textSupliment }}
                                cssStyle={{
                                    ...textSuplimentDefaultStyle,
                                    ...{
                                        backColor: backColor,
                                        color: backColor === '#fff' ? 'rgb(145,145,145)' : 'rgb(105,105,105)',
                                    },
                                }}
                            />
                        </div>
                    </div>
                    {item.showVideo ? (
                        <div className="videoBox" style={{ marginTop: '.3rem' }}>
                            <VideoModule
                                config={{
                                    height: '3rem',
                                    src: item.videoUrl,
                                    autoPlay: true,
                                    hideControl: true,
                                    muted: true,
                                    loop: videoLoop,
                                }}
                            />
                        </div>
                    ) : (
                        <div className="imgBox signFullImgsBox" style={{ marginTop: '.3rem' }}>
                            {Array.isArray(item.imgUrl) ? (
                                <EFPic name={item.imgUrl} alt={t(item.tab)} />
                            ) : (
                                <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                            )}
                        </div>
                    )}
                </div>
            )}
            {/* 3. 非全屏图片 position: center */}
            {position == 'center' && (
                <div className="wrapper wrapperRight">
                    <div className={backColor === '#fff' ? 'container whiteTab' : 'container blackTab'}>
                        <div className="tabBox">
                            <ul className="tabsWrapper" onTouchStart={touchStart} onTouchMove={touchMove}>
                                {data.map((list: any, k: number) => (
                                    <li
                                        className={`tab font-family-semibold ${activeKey === k ? 'activeTab' : ''} ${
                                            backColor === '#fff' ? 'whiteTab' : 'blackTab'
                                        }`}
                                        key={k}
                                        onClick={() => activeKey !== k && changeTab(k)}
                                    >
                                        {list.tab}
                                    </li>
                                ))}
                                <p className="line" style={{ opacity: backColor === '#fff' ? '1' : '0.2' }}></p>
                            </ul>
                        </div>
                        <div className="textContainer" style={{ padding: 0 }}>
                            <TextModule
                                data={{ text: item.textDesc }}
                                cssStyle={{
                                    ...textDescDefaultStyle,
                                    ...{
                                        margin: '.3rem 0 .13rem 0',
                                        backColor: backColor,
                                        color: backColor === '#fff' ? '#03060b' : 'rgb(145,145,145)',
                                        padding: '0 .2rem',
                                    },
                                }}
                            />
                        </div>
                        {item.showVideo ? (
                            <div className="videoBox">
                                <VideoModule
                                    config={{
                                        height: '3rem',
                                        src: item.videoUrl,
                                        autoPlay: true,
                                        hideControl: true,
                                        muted: true,
                                        loop: videoLoop,
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                className="imgBox signFullImgsBox"
                                style={{
                                    width: '3.35rem',
                                    height: '3.2rem',
                                    borderRadius: '.2rem',
                                    overflow: 'hidden',
                                }}
                            >
                                {Array.isArray(item.imgUrl) ? (
                                    <EFPic name={item.imgUrl} alt={t(item.tab)} />
                                ) : (
                                    <Image src={item.imgUrl} layout="fill" alt={t(item.tab)} />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
